export const MainWrapper = ({ children }) => (
  <main>
    <div className="container pt-4">{children}</div>
  </main>
);
